module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-mobile-duel-0e979369a21356f8dfbd0da0de07ee33.png";